module.exports = __webpack_public_path__ + "img/Menu.34e733e0.svg";